import React from 'react';
import { IconButton } from 'src/common/icon-button';
import { UploadStack } from 'src/common/store/files-upload.store';
import { CloseStrongIcon } from 'src/monet/icons';

interface Props {
  name: string;
  stack: UploadStack;
}

export const DashboardLibraryContentUploadBubbleItem = ({ name, stack }: Props) => {
  const renderUploadStateContent = (stack: UploadStack) => {
    if (stack.cancelled) {
      return <span>Upload cancelled</span>;
    }
    if (!stack.done) {
      return (
        <>
          <span>{stack.progress}%</span>
          <IconButton
            disabled={!stack.cancellable}
            onClick={() => {
              stack.abortCall();
            }}
          >
            <CloseStrongIcon />
          </IconButton>
        </>
      );
    }

    if (stack.copyText) {
      return <span>{stack.copyText}</span>;
    }

    return <span>Upload completed</span>;
  };

  return (
    <div className='flex items-center justify-between space-x-2 text-bedrock-p'>
      <span className='truncate'>{name}</span>
      <div className='w-32 shrink-0 flex gap-2 items-center justify-end'>{renderUploadStateContent(stack)}</div>
    </div>
  );
};
